/**
 * Placing what was picked in the build menu: its blueprint waits in the store (`placing`) while I
 * walk to where it should stand; the world shows it there, see-through, and the Place button
 * places it. Whether it can stand on the tile under me is the rules' own check of the action that
 * places it, so the reason shown is always theirs.
 */
import type { Game } from '../game';
import { actionCheck, submitAction, type ActionCheck } from '../intents/submit';
import { closePanel } from '../view/panels';
import { placeAction, type Blueprint } from './blueprints';

/** Whether what I'm placing can stand on the tile under me now. */
export type Placement = ActionCheck;

/** Start placing `blueprint`: the build menu closes, the preview stands where I stand. */
export function startPlacing(game: Game, blueprint: Blueprint): void {
  closePanel(game);
  game.store.set({ placing: blueprint });
}

export function stopPlacing(game: Game): void {
  if (game.store.get().placing) game.store.set({ placing: null });
}

/** Where placing stands on the tile under me; null while I'm not placing or not on the planet. */
export function placementCheck(game: Game): Placement | null {
  const s = game.store.get();
  if (!s.placing || !s.view || !s.me || s.here < 0) return null;
  return actionCheck(game, placeAction(s.placing, s.here));
}

/** Place it on the tile under me, if it can stand there; placing ends when it's on its way. */
export function confirmPlacing(game: Game): boolean {
  const placement = placementCheck(game);
  if (placement?.state !== 'ok' || !submitAction(game, placement.action)) return false;
  stopPlacing(game);
  return true;
}
